import { ISearch } from './ISearch.model';
import { ActionPlanItem } from './action-plan-item.model';
import { Icon } from './icon.model';
import { ResponsiblesPipe } from '../../plugins/observationsandrecommandations/responsibles.pipe';
import * as _ from 'lodash';

export class ActionPlanGroupedItemsModel implements ISearch {
  public prog: number;
  public icons: Icon[] = [];

  public search(query: string): boolean {
    return true;
  }

  constructor(public side: number, public actionPlanItems: ActionPlanItem[]) {
    this.icons = [];
  }

  public getProgression(): number {
    this.prog =
      this.actionPlanItems.length === 0
        ? 0
        : Math.round((this.getPointDoneCount() / this.actionPlanItems.length) * 100);
    return this.prog;
  }

  public getPointDoneCount(): number {
    return _.sumBy(this.actionPlanItems, (api: ActionPlanItem) => (api.isComplete() ? 1 : 0));
  }
}
